import Phaser from 'phaser';
import { GAME_W, GAME_H, TILE } from '../constants';
import { SpriteAtlasLoader } from '../animation/SpriteAtlasLoader';

export default class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    SpriteAtlasLoader.preload(this);

    this.add.rectangle(GAME_W / 2, GAME_H / 2, GAME_W, GAME_H, 0x091c24);
    this.add.text(GAME_W / 2, GAME_H / 2 - 55, 'BLAST ARENA', {
      fontFamily: 'Arial', fontStyle: 'bold', fontSize: '40px', color: '#edf7f2',
    }).setOrigin(0.5);
    this.add.text(GAME_W / 2, GAME_H / 2 - 10, 'PREGĂTIM INSULA', {
      fontFamily: 'Arial', fontSize: '13px', color: '#8ed4bd', letterSpacing: 3,
    }).setOrigin(0.5);
    this.add.rectangle(GAME_W / 2, GAME_H / 2 + 38, 320, 4, 0x244846);
    const progress = this.add.rectangle(GAME_W / 2 - 160, GAME_H / 2 + 38, 0, 4, 0xe0efbe).setOrigin(0, 0.5);
    this.load.on('progress', (value: number) => progress.width = 320 * value);
  }

  create(): void {
    SpriteAtlasLoader.create(this);
    this.genExit();
    this.scene.start('MainMenuScene');
  }

  private genExit(): void {
    const g = this.add.graphics();
    g.fillStyle(0x000a22, 1);
    g.fillRect(0, 0, TILE, TILE);
    g.fillStyle(0x003366, 0.6);
    g.fillCircle(TILE / 2, TILE / 2, 30);
    g.fillStyle(0x0066cc, 0.7);
    g.fillCircle(TILE / 2, TILE / 2, 24);
    g.fillStyle(0x00aaff, 0.85);
    g.fillCircle(TILE / 2, TILE / 2, 18);
    g.fillStyle(0x00ddff, 1);
    g.fillCircle(TILE / 2, TILE / 2, 12);
    g.fillStyle(0xffffff, 1);
    g.fillCircle(TILE / 2, TILE / 2, 6);
    g.fillStyle(0x00ffff, 1);
    g.fillRect(TILE / 2 - 1, 6, 2, 8);
    g.fillRect(TILE / 2 - 1, TILE - 14, 2, 8);
    g.fillRect(6, TILE / 2 - 1, 8, 2);
    g.fillRect(TILE - 14, TILE / 2 - 1, 8, 2);
    g.generateTexture('tex_exit', TILE, TILE);
    g.destroy();
  }

}
